class GeometryDialogComponent extends HTMLElement {

  columnWidth = 8
  wallWidth = 8
  footingWidth = 24
  footingThickness = 8

  constructor() {
    super()
    document.addEventListener('project-loaded', async (event) => this.onProjectLoaded(event.detail.geometry), true)
  }

  /**
   * Create our view model and configure the view
   * @param {Geometry} model
   * 
   */
   onProjectLoaded(model) {
    this.columnWidth = model.columnWidth
    this.wallWidth = model.wallWidth
    this.footingWidth = model.footingWidth
    this.footingThickness = model.footingThickness
    this.configure()
  }

  configure() {
    document.getElementById('footing-width').value = this.footingWidth
    document.getElementById('footing-thickness').value = this.footingThickness
    document.getElementById('column-width').value = this.columnWidth
    document.getElementById('wall-width').value = this.wallWidth
  }

  publishUpdate() {
    const event = new CustomEvent('geometry-dialog-update', { detail: this });
    this.dispatchEvent(event)
  }

  onBlur() {
    let footingWidth = parseInt(document.getElementById("footing-width").value)
    let footingThickness = parseInt(document.getElementById("footing-thickness").value)
    let columnWidth = parseInt(document.getElementById("column-width").value)
    let wallWidth = parseInt(document.getElementById("wall-width").value)
    
    if(isNaN(footingWidth) || footingWidth <= 0) {
      document.getElementById('geometry-validation').classList.remove('d-none')
      document.getElementById('geometry-validation').innerHTML = 'Footing width must be larget than 0.'
      return
    }

    if(isNaN(footingThickness) || footingThickness <= 0) {
      document.getElementById('geometry-validation').classList.remove('d-none')
      document.getElementById('geometry-validation').innerHTML = 'Footing thickness must be larget than 0.'
      return
    }

    if(isNaN(columnWidth) || columnWidth <= 0) {
      document.getElementById('geometry-validation').classList.remove('d-none')
      document.getElementById('geometry-validation').innerHTML = 'Column width must be larget than 0.'
      return
    }

    if(isNaN(wallWidth) || wallWidth <= 0) {
      document.getElementById('geometry-validation').classList.remove('d-none')
      document.getElementById('geometry-validation').innerHTML = 'Wall width must be larget than 0.'
      return
    }

    if(wallWidth > footingWidth) {
      document.getElementById('geometry-validation').classList.remove('d-none')
      document.getElementById('geometry-validation').innerHTML = 'Footing must be larger than wall.'
      return
    }

    if(columnWidth > footingWidth) {
      document.getElementById('geometry-validation').classList.remove('d-none')
      document.getElementById('geometry-validation').innerHTML = 'Footing must be larger than column.'
      return
    }

    document.getElementById('geometry-validation').classList.add('d-none')

    this.footingWidth = footingWidth
    this.footingThickness = footingThickness
    this.columnWidth = columnWidth
    this.wallWidth = wallWidth

    this.publishUpdate()
  }
  
  connectedCallback() {
    this.innerHTML = String.raw`
      <div class="card">
      <div class="card-header hidden-print">Footing</div>
        <div class="card-body hidden-print">
          <div style="margin:10px 0 10px 0;">
            <span>Footing Width (in) <input style="width:50px;" class='text-center' id="footing-width" type="text" 
              name="footing-width" value="${this.footingWidth}" /></span>
            <span class="pull-right">Footing Thickness (in) <input style="width:50px;" class='text-center' id="footing-thickness" type="text"
                name="footing-thickness" value="${this.footingThickness}"/></span>
          </div>
          <div>
            <span id='geometry-input-column-width'>Column Width (in) <input style="width:50px;" class='text-center' id="column-width" type="text" 
              name="column-width" value="${this.columnWidth}" /></span>
            <span id='geometry-input-wall-width' class="d-none">Wall Width (in) <input style="width:50px;" class='text-center' id="wall-width"
                type="text" name="wall-width" value="${this.wallWidth}"/></span>
          </div>
          <div style="margin-top:10px;" id="geometry-validation" class="alert alert-danger d-none">
            Footing width must be greater than 0 and larger than column or wall width.
          </div>
        </div>
      </div>
    `
    document.getElementById('footing-width').onblur = (() => this.onBlur())
    document.getElementById('footing-thickness').onblur = (() => this.onBlur())
    document.getElementById('column-width').onblur = (() => this.onBlur())
    document.getElementById('wall-width').onblur = (() => this.onBlur())

    this.configure()
  }
}

customElements.define('geometry-dialog-component', GeometryDialogComponent)